/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Large_Json_Files_S7_P1Inputs */

const en_guide_large_json_files_s7_p1 = /** @type {(inputs: Guide_Large_Json_Files_S7_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Large JSON becomes a problem in two different places: the program that has to hold it in memory, and the person who has to make sense of it. The two need different fixes, so it helps to know which one you are hitting before reaching for a tool.`)
};

const ko_guide_large_json_files_s7_p1 = /** @type {(inputs: Guide_Large_Json_Files_S7_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`큰 JSON은 두 곳에서 문제가 됩니다. 그것을 메모리에 담아야 하는 프로그램과, 그것을 이해해야 하는 사람입니다. 둘은 서로 다른 해법이 필요하므로, 도구를 꺼내기 전에 지금 어느 쪽에 부딪혔는지 아는 것이 도움이 됩니다.`)
};

const ja_guide_large_json_files_s7_p1 = /** @type {(inputs: Guide_Large_Json_Files_S7_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大きな JSON は二つの異なる場所で問題になります。それをメモリに保持しなければならないプログラムと、それを理解しなければならない人です。二つは別々の対処が必要なので、ツールに手を伸ばす前に、今どちらにぶつかっているかを知ると役立ちます。`)
};

/**
* | output |
* | --- |
* | "Large JSON becomes a problem in two different places: the program that has to hold it in memory, and the person who has to make sense of it. The two need dif..." |
*
* @param {Guide_Large_Json_Files_S7_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_large_json_files_s7_p1 = /** @type {((inputs?: Guide_Large_Json_Files_S7_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Large_Json_Files_S7_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_large_json_files_s7_p1(inputs)
	if (locale === "ko") return ko_guide_large_json_files_s7_p1(inputs)
	return ja_guide_large_json_files_s7_p1(inputs)
});